import { z } from "zod"

export const optionalString = <T extends z.ZodString>(schema: T) => z.union([schema, z.literal("")])
